import { Component } from '@angular/core'; 

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'ltts-frontend';
 
  policyUrl = 'https://sites-policies.italiaonline.it/cookie-policy.html?alias=4b9f987a';
}
